import { Form, FormikProvider, useFormik } from 'formik';
import { useEffect, useState } from 'react';
import * as Yup from 'yup';
// material
import { LoadingButton } from '@mui/lab';
import {
  Avatar,
  Grid,
  MenuItem,
  Stack,
  styled,
  TextField,
  Typography
} from '@mui/material';
// component
import axios from 'axios';
import { toast } from 'react-toastify';
import FileInputField from './FileInputField';

// ----------------------------------------------------------------------

const StyledLabelTypography = ({ title }) => {
  const StyledTypography = styled(Typography)(({ theme }) => ({
    color: '#000',
    fontFamily: 'Inter',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
  }));
  return (
    <StyledTypography>
      {title}
      <span style={{ color: 'red' }}>*</span>
    </StyledTypography>
  );
};

export default function AddCategoryForm({ closePopup, handleAddSuccess }) {
  const [showPassword, setShowPassword] = useState(false);
  const [icon, setIcon] = useState(null);

  const RegisterSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
  });

  const formik = useFormik({
    initialValues: {
      name: '',
      isBlocked: false,
    },
    validationSchema: RegisterSchema,
    onSubmit: async () => {
      console.log('clicked');
      try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/category`, values);
        console.log(response);
        if (!response.data.isError) {
          toast.success(response.data.message);
          handleAddSuccess();
          closePopup();
        } else {
          console.log(response.data);
          toast.error(response.data.message);
        }
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message);
        return false;
      }
    },
  });

  const { errors, touched, handleSubmit, values, isSubmitting, getFieldProps } = formik;

  useEffect(() => {
    if (values.icon) {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          setIcon(reader.result);
        }
      };
      reader.readAsDataURL(values.icon);
    }
  }, [values.icon]);

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Grid container spacing={2} rowGap={2} mt={1}>
          <Grid item xs={12}>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={{
                xs: 1.5,
                sm: 3,
              }}
              alignItems={{ xs: 'left', sm: 'center' }}
              sx={{ width: '100%' }}
            >
              <StyledLabelTypography title={'Icon'} />
              <Stack direction={'row'} spacing={2} alignItems={'center'} sx={{ width: '100%' }}>
                <Avatar alt="Remy Sharp" src={icon} sx={{ width: 56, height: 56 }} />
                <FileInputField
                  onChange={(e) => formik.setFieldValue('icon', e.target.files[0])}
                  value={formik.values.icon}
                  accept=".jpg, .jpeg, .png"
                />
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Stack direction={'column'} spacing={1.5}>
              <StyledLabelTypography title={'Name'} />
              <TextField
                size="small"
                fullWidth
                placeholder="Name"
                {...getFieldProps('name')}
                error={Boolean(touched.name && errors.name)}
                helperText={touched.name && errors.name}
              />
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Stack direction={'column'} spacing={1.5}>
              <StyledLabelTypography title={'Status'} />
              <TextField
                select
                placeholder="Status"
                size="small"
                name="isBlocked"
                {...getFieldProps('isBlocked')}
                onChange={formik.handleChange}
              >
                <MenuItem value={'false'}>Active</MenuItem>
                <MenuItem value={'true'}>Blocked</MenuItem>
              </TextField>
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <Stack sx={{ width: '100%' }} direction={'row'} spacing={2} justifyContent={'center'}>
              <LoadingButton
                size="small"
                type="submit"
                variant="contained"
                loading={isSubmitting}
                sx={{ fontFamily: 'Inter' }}
              >
                Submit
              </LoadingButton>
            </Stack>
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  );
}
